import React from "react";
import About from "../components/About";
import Ideology from "../components/Ideology";
import Introduction from "../components/Introduction";
import Showcase from "../components/Showcase";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Technologies from "../components/Technologies";
import Team from "../components/Team";
import Testimonial from "../components/Testimonial";
import Process from "../components/Process";

const Home = () => {
  return (
    <>
      {/* Navigation Bar */}
      <Header />

      {/* Banner Five */}
      <Introduction />

      {/* About Area Five */}
      <About />

      {/* Service Area Five */}
      <Technologies />

      {/* Case Study Area Two */}
      <Showcase />

      {/* About Area Six */}
      <Ideology />

      {/* Team Area Three */}
      <Team />

      {/* Work Process Four */}
      <Process />

      {/* Testimonial Five */}
      <Testimonial />

      {/* Footer Four */}
      <Footer />
    </>
  );
};

export default Home;
